let apidaePrestasLayoutMode = {

    props: {
        showMap: Number,
        layoutMode: String
    },
    computed: {

    },
    components: {

    },
    directives: {

    },
    data() {
        return {

        }
    },
    methods: {
        layoutmodeevent() {
            this.$root.changelayoutmode(event);
            // this.layoutMode = 'map'
        },
    },
    template: `
        <div class="button-single layout-mode-button-single" v-if="showMap">
            Afficher la carte :
            <button class="mapLayout mapResize switch-button" :class="(layoutMode == 'map') ? 'is-checked' : ''">
                <svg @click="layoutmodeevent" style="height: 30px; width: 30px; display: block; overflow: visible;" viewBox="0 0 52 52" fill="currentColor" fill-opacity="0" stroke="currentColor" stroke-width="3" focusable="false" aria-hidden="true" role="presentation" stroke-linecap="round" stroke-linejoin="round"><path d="m19.1 19.1 l14 14 m 0 -14 l -14 14"></path></svg>
            </button>
        </div>`
}


// change layout mode
// $('.layout-mode-button-single').on( 'click', 'button', function() {
//     $(this).toggleClass('is-checked');
//     var layoutModeValue = $(this).data('layout-mode');
//     theGrid.toggleClass(layoutModeValue);
//     setTimeout(gridLayout, 300);
// });

// change is-checked class on buttons
// $('.button-group').each( function( i, buttonGroup ) {
//     var $buttonGroup = $( buttonGroup );
//     $buttonGroup.on( 'click', 'button', function() {
//         $buttonGroup.find('.is-checked').removeClass('is-checked');
//         $(this).addClass('is-checked');
//     });
// });